import { useEffect, useRef } from "react";

// Polls `fn` every `ms` while the page is visible; pauses when hidden; refreshes immediately on return.
export function useVisiblePolling(fn, ms = 5000) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    let timer = null;
    const tick = () => ref.current();
    const start = () => { if (!timer) timer = setInterval(tick, ms); };
    const stop = () => { clearInterval(timer); timer = null; };
    const onVisible = () => {
      if (document.visibilityState === "visible") { tick(); start(); } else stop();
    };
    tick();
    if (document.visibilityState === "visible") start();
    document.addEventListener("visibilitychange", onVisible);
    return () => { stop(); document.removeEventListener("visibilitychange", onVisible); };
  }, [ms]);
}
